export const environment = {
  production: true,
  backedConfigs: {
    //base_url: 'BACKEND_URL'
    base_url: 'https://fsnc-backend.travio.it/api'
  }
};
